import { render, staticRenderFns } from "./CardItemA.vue?vue&type=template&id=559384aa&scoped=true&"
import script from "./CardItemA.vue?vue&type=script&lang=js&"
export * from "./CardItemA.vue?vue&type=script&lang=js&"
import style0 from "./CardItemA.vue?vue&type=style&index=0&id=559384aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559384aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
